import {
  ChannelLevel,
  DeliveryChannel,
  DeliveryStatus,
  NotificationSeverity,
  SEVERITY,
} from './models'

export type Tone = 'info' | 'ok' | 'warn' | 'bad'

export const severityTone = (severity: NotificationSeverity): Tone =>
  severity === SEVERITY.success
    ? 'ok'
    : severity === SEVERITY.warning
    ? 'warn'
    : severity === SEVERITY.error
    ? 'bad'
    : 'info'

export const severityLabel = (severity: NotificationSeverity) =>
  severity === SEVERITY.success
    ? 'موفق'
    : severity === SEVERITY.warning
    ? 'هشدار'
    : severity === SEVERITY.error
    ? 'خطا'
    : 'اطلاع'

export const severityIcon = (severity: NotificationSeverity) =>
  severity === SEVERITY.success
    ? 'la-check-circle'
    : severity === SEVERITY.warning
    ? 'la-exclamation-triangle'
    : severity === SEVERITY.error
    ? 'la-times-circle'
    : 'la-info-circle'

export const LEVEL_OPTIONS: Array<{value: ChannelLevel; label: string; hint: string}> = [
  {value: 'off', label: 'خاموش', hint: 'هیچ پیامی از این کانال فرستاده نمی‌شود'},
  {value: 'errors', label: 'فقط خطاها', hint: 'فقط رویدادهای با سطح «خطا»'},
  {value: 'warnings', label: 'هشدار و خطا', hint: 'رویدادهای «هشدار» و «خطا»'},
  {value: 'all', label: 'همه', hint: 'همهٔ رویدادهای این گروه'},
]

export const levelLabel = (level: ChannelLevel) =>
  LEVEL_OPTIONS.find((option) => option.value === level)?.label || level

export const channelLabel = (channel: DeliveryChannel) =>
  channel === 'sms'
    ? 'پیامک'
    : channel === 'telegram'
    ? 'تلگرام'
    : channel === 'ticket'
    ? 'تیکت پشتیبانی'
    : 'داخل پنل'

export const deliveryStatusLabel = (status: DeliveryStatus) =>
  status === 'sent'
    ? 'ارسال شد'
    : status === 'failed'
    ? 'ناموفق'
    : status === 'skipped'
    ? 'ارسال نشد'
    : status === 'cancelled'
    ? 'لغو شد'
    : 'در صف ارسال'

export const deliveryStatusTone = (status: DeliveryStatus): Tone =>
  status === 'sent' ? 'ok' : status === 'failed' ? 'bad' : status === 'pending' ? 'info' : 'warn'

/** Persian reasons for the machine codes the backend stores on a skipped delivery. */
export const skipReasonLabel = (error?: string | null) => {
  switch (error) {
    case 'telegram_not_connected':
      return 'حساب گیرنده به تلگرام متصل نیست'
    case 'mobile_missing':
      return 'شماره موبایل تأییدشده‌ای ثبت نیست'
    case 'sms_disabled':
    case 'telegram_disabled':
    case 'ticket_disabled':
    case 'crm_disabled':
      return 'این کانال در سرور غیرفعال است'
    case 'actor_not_member':
      return 'کاربر نمایندهٔ کسب‌وکار پیدا نشد'
    case 'sms_service_off':
      return 'سرویس «پیامک اعلان‌ها» برای کسب‌وکار فعال نیست'
    default:
      return error || ''
  }
}
